import { HttpClient } from '@angular/common/http'
import { Inject, Injectable } from '@angular/core'
import { ILanguageService } from '../Interface/language.interface'
import { BaseApiService } from './base-api.service'
import { LocalStorageShoppingCart } from './cart.service'
import { CoreEnvironmentService } from './core-environment.service'
import { UtilsService } from './utils.service'

type BeatType = {
  beatId: number
  discount: number
  fullPrice: number
  hasDiscount: boolean
  isOK: boolean
  licenseId: string
  message: null | string
  priceWithDiscount: number
}

type BulkDiscountType = {
  bonusLicenseCount: number
  bonusLicenseName: string
  buyLicenseCount: number
  buyLicenseName: string
}

export type CheckResponseType = {
  cashbackAmount: number
  fullPrice: number
  hasDiscount: boolean
  hasRequiredPassportLicense: boolean
  isOK: boolean
  priceWithDiscount: number
  bulkDiscounts: Array<BulkDiscountType>
  beats: Array<BeatType>
}

export type ClientDataType = {
  fullName: MultiLangStringType
  passportData: MultiLangStringType
  email: string
}

type MultiLangStringType = {
  ru: string
  en: string
}

@Injectable({
  providedIn: 'root'
})
export class CartApiService extends BaseApiService {
  constructor(
    public http: HttpClient,
    public environment: CoreEnvironmentService,
    public utilsService: UtilsService,
    @Inject('ILanguageService') private languageSevice: ILanguageService
  ) {
    super(http, environment, utilsService)
  }

  getBeatLicenses(beatId: number) {
    return this.makeRequest('GET', '/web/v1/licenses', { eng: false, beatId })
  }

  getBeatsLicenses(beatsIds: number[]) {
    const isEng = this.languageSevice.isEng()
    return this.makeRequest('GET', '/web/v1/licenses/GetForBeats', { eng: isEng, beatsIds })
  }

  getBeats(beatsIds: number[]) {
    const isEng = this.languageSevice.isEng()
    return this.makeRequest('GET', '/web/v1/beats/GetBeatsByIds', { eng: isEng, ids: beatsIds })
  }

  getClientData() {
    return this.makeRequest('GET', '/web/v1/cart/get-client-data', {}) as Promise<ClientDataType>
  }

  checkCoupon(
    beatmakerId: number,
    coupon: string,
    beatsWithLicense: LocalStorageShoppingCart[]
  ): Promise<CheckResponseType> {
    const isEng = this.languageSevice.isEng()
    return this.makeRequest('POST', '/web/v1/cart/check', {
      eng: isEng,
      beatmakerId,
      coupon,
      beats: beatsWithLicense.map(item => {
        return { beatId: item.beatId, licenseId: item.licenseId }
      })
    })
  }

  isConfirmed(paymentId, altPaymentId) {
    const data = { paymentId, altPaymentId }
    return this.makeRequest('POST', '/web/v1/cart/is-confirmed', data).then(response => response.data)
  }

  getUrl(url, data) {
    return this.makeRequest('POST', url, data)
  }

  getPaymentsTypes(beatmakerId: number) {
    return this.makeRequest('GET', '/web/v1/cart/get-payment-types', { beatmakerId })
  }
}
